import React from 'react';
import {Box, Stack, Theme, useMediaQuery} from '@mui/material';
import LeadForm from './LeadForm';
import Reviews from './Reviews';
import Info from './Info';

const styles = {
    wrapper: {
        mt: {xs: '30px', md: 6},
    },
    leadFormWrapper: {
        width: {md: '88%'},
        mx: 'auto',
        pb: '28px',
    },
    imageWrapper: {
        mx: {xs: 2, md: 0},
        width: {md: '50%'},
        maxWidth: {xs: '368px', sm: '540px', md: '775px'},
        height: 'fit-content',
        mt: 4,
        alignSelf: 'center',
    },
    image: {
        width: '100%',
        objectFit: 'cover',
        position: 'relative',
        zIndex: 1,
        borderRadius: '21px',
    },
    formWrapper: {
        maxWidth: {xs: '100%', md: '40%'},
        px: {xs: 3, md: 0},
    },
};

interface CustomerInformationV2Props {
    onNextClick: () => Promise<void>;
}

const CustomerInformationV2: React.FC<CustomerInformationV2Props> = ({onNextClick}) => {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    return (
        <Box sx={styles.wrapper}>
            <Stack
                spacing={{xs: 5, md: 15}}
                direction={{xs: 'column-reverse', md: 'row'}}
                justifyContent={'center'}
                sx={styles.leadFormWrapper}
            >
                <Box sx={styles.imageWrapper}>
                    {isMobile ? (
                        <Box component="img" sx={styles.image} src="/images/mql-hero-mobile.webp" alt="image" />
                    ) : (
                        <Box component="img" sx={styles.image} src="/images/mql-hero-desktop.webp" alt="image" />
                    )}
                </Box>
                <Box sx={styles.formWrapper}>
                    <LeadForm onNextClick={onNextClick} />
                </Box>
            </Stack>
            <Reviews />
            <Info />
        </Box>
    );
};

export default CustomerInformationV2;
